import { Ref } from 'vue'
import { buildDefaultRequestErrorHandler } from '@/repositories/errorHandler'

export async function callApiWrapper (requestError: Ref<string | null>, action: () => Promise<void>) {
  try {
    await action()
  } catch (e) {
    buildDefaultRequestErrorHandler(requestError, e).handle()
  }
}
